var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full",attrs:{"id":"capture-detail"}},_vm._l((_vm.logs),function(log,index){return _c('div',{key:index},[(log !== undefined)?_c('log-item',{staticClass:"mb-base",attrs:{"item":log}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }